import * as React from 'react';
import { connect } from 'react-redux';

import {
  copyAllPhrasesToTimeline,
  toggleCaptions,
} from 'redux/modules/embed/actions';
import { captionsStyleLockStateSelector } from 'redux/modules/embed/selectors';
import { onCopyAllCaptions } from 'redux/modules/mixpanel/actions';
import { showError } from 'redux/modules/notification/actions';
import { Dispatch, State } from 'redux/types';
import { CaptionsFormProps } from './CaptionsForm';

export type StateProps = Pick<CaptionsFormProps, 'captionsStyleLockState'>;

export type DispatchProps = Pick<
  CaptionsFormProps,
  'onToggleCaptions' | 'onCopyAllToTimeline'
>;

const mapStateToProps = (state: State): StateProps => ({
  captionsStyleLockState: captionsStyleLockStateSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onCopyAllToTimeline: () => {
    dispatch(onCopyAllCaptions());
    dispatch(copyAllPhrasesToTimeline());
  },
  onToggleCaptions: enabled =>
    dispatch(toggleCaptions(enabled)).catch(() => {
      const message = `Error ${enabled ? 'enabling' : 'disabling'} captions`;
      dispatch(showError(message));
    }),
});

export default function(component: React.ComponentType<CaptionsFormProps>) {
  return connect(mapStateToProps, mapDispatchToProps)(component);
}
